import { useQuery } from "react-query";
import { EventParticipationAPI } from "api/eventParticipation";
import { EVENT_PARTICIPATION } from "helpers/constants";

export default function useEventParticipation(enabled = true) {
  return useQuery(EVENT_PARTICIPATION, EventParticipationAPI.getAllForUser, {
    enabled,
  });
}
